import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

const boxStyle = {
  paddingTop: 10,
  paddingBottom: 10,
};

const BasicHeader = ({ title }) => (
  <div className="influencer-context-bar" style={boxStyle}>
    <Grid style={boxStyle}>
      <Grid.Row columns="two">
        <Grid.Column>
          <h1>{title}</h1>
        </Grid.Column>
        <Grid.Column />
      </Grid.Row>
    </Grid>
  </div>
);

BasicHeader.propTypes = {
  title: PropTypes.string.isRequired,
};


export default BasicHeader;



/** WEBPACK FOOTER **
 ** ./src/components/basic-header/index.js
 **/